import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/92e06c1d-61eb-4595-95ba-65aac2d607ba";
export const REGISTER_URL = "https://a.ntrk2.com/e80b02a9-ecd9-4579-b423-9b3f714bd69c";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://pkeasy.loadprkw2a.com/download?openExternalBrowser=1&id=73s5cp1s1gkye02";

export * from "./codes";
export * from "./context";
